import React, { useMemo, useRef } from "react";
import { MapContainer, GeoJSON } from "react-leaflet";
import L from "leaflet";
import "./BorrowingMap.css";

const centerIndia = [22.5, 82];

function valueToColor(p, metric) {
  const clamp = Math.max(0, Math.min(1, Number.isFinite(p) ? p : 0));

  if (metric === "borrowed_yes") {
    const r = Math.round(236 + (147 - 236) * clamp);
    const g = Math.round(223 + (51 - 223) * clamp);
    const b = Math.round(253 + (234 - 253) * clamp);
    return `rgb(${r},${g},${b})`;
  } else {
    const r = Math.round(243 + (168 - 243) * clamp);
    const g = Math.round(232 + (138 - 232) * clamp);
    const b = Math.round(255 + (222 - 255) * clamp);
    return `rgb(${r},${g},${b})`;
  }
}

export default function BorrowingMap({ geo, metrics, metric, onHoverPurpose }) {
  const geoRef = useRef(null);

  const styleFn = (feature) => {
    const name = feature.properties?.st_nm;
    const val = metrics?.[name]?.[metric] ?? 0;
    return {
      fillColor: valueToColor(val, metric),
      color: "#4c1d95",
      weight: 1,
      fillOpacity: 0.85,
    };
  };

  const onEachFeature = (feature, layer) => {
    const name = feature.properties?.st_nm;
    const data = metrics?.[name] || {};
  
    layer.on({
      click: () => {
        if (onHoverPurpose && data.purposes) {
          onHoverPurpose(data.purposes, name);
        }
      },
    });
  
    const pct = (v) =>
      v === null || v === undefined ? "—" : `${(v * 100).toFixed(1)}%`;
  
    // ✅ use let instead of const
    let html = `
      <div class="borrow-tooltip">
        <div><b>${name}</b></div>
        <div>Borrowed: <b>${pct(data.borrowed_yes)}</b></div>
        <div>Not Borrowed: <b>${pct(data.borrowed_no)}</b></div>
    `;
  
    if (data.sources && Object.keys(data.sources).length) {
      html += `<div><b>Sources:</b></div>`;
      for (const [src, val] of Object.entries(data.sources)) {
        html += `<div>${src}: ${pct(val)}</div>`;
      }
    }
  // 👇 add the "Click to view Purpose of loan" text here
html += `<div style="margin-top:6px; font-size:12px; color:#007bff; cursor:pointer;">
Click to view Purpose of loan
</div>`;
    html += `</div>`; // ✅ closing wrapper
  
    layer.bindTooltip(html, {
      sticky: true,
      direction: "top",
      opacity: 0.95,
      className: "custom-tooltip",
    });
  };
  

  const bounds = useMemo(() => {
    try {
      const gj = L.geoJSON(geo);
      return gj.getBounds();
    } catch {
      return null;
    }
  }, [geo]);

  return (
    <MapContainer
      className="map-container"
      center={centerIndia}
      zoom={5}
      scrollWheelZoom={false}
      bounds={bounds || undefined}
      attributionControl={false}
    >
      <GeoJSON
        ref={geoRef}
        data={geo}
        style={styleFn}
        onEachFeature={onEachFeature}
      />

      <div className="legend">
        <div>{metric === "borrowed_yes" ? "Borrowed (%)" : "Not Borrowed (%)"}</div>
        <div
          className="legend-bar"
          style={{
            background:
              metric === "borrowed_yes"
                ? "linear-gradient(to right, #ede9fe, #7e22ce)"
                : "linear-gradient(to right, #f3e8ff, #a855f7)",
          }}
        ></div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>0%</span>
          <span>100%</span>
        </div>
      </div>
    </MapContainer>
  );
}
